import AdminSettingsPage from '../../../sections/AdminDashboard/Settings/AdminSettingsPage';

export default AdminSettingsPage;
